import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './spinner-5-axis-milling/HeroSection';
import { MachineModelsSection } from './spinner-5-axis-milling/MachineModelsSection';
export function Spinner5AxisMillingPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-3980">
      <SeoBar data-id="element-3981" />
      <Header data-id="element-3982" />
      <main className="flex-grow" data-id="element-3983">
        <div className="w-full bg-white pb-20" data-id="element-3984">
          <HeroSection data-id="element-3985" />
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-3986">
            <MachineModelsSection data-id="element-3987" />
          </div>
        </div>
      </main>
      <Footer data-id="element-3988" />
    </div>;
}